import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'supplyChain',
        component: () => import('@/views//product/supplyChain'),
        meta: {
            title: '供应链管理系统_供应链平台_供应链系统平台|金现代供应链平台',
            keywords: '供应链管理，供应链管理平台，供应链体系，供应链系统，智慧供应链',
            description: '金现代供应链平台，以物资供应链全过程为主线，以大数据、云计算、物联网、移动应用、人工智能、区块链等新一代信息技术为纽带，全力打造现代智慧供应链体系。'
        }
    },
    {
        path: '/product/business',
        name: 'business',
        component: () => import('@/views//product/business'),
        meta: {
            title: '供应链运营平台_智慧供应链_供应链系统|金现代供应链运营平台',
            keywords: '采购供应链解决方案，供应链运营管理，供应链平台，供应链数字化管理平台，数字化供应链系统',
            description: '金现代供应链运营平台，应用“大云物移智链”等新技术，构建计划、采购、物流、配送、供应链伙伴、运营决策六大业务场景，内外高效协同、智慧运营的现代智慧供应链体系。'
        }
    },
    {
        path: '/product/bidding',
        name: 'bidding',
        component: () => import('@/views//product/bidding'),
        meta: {
            title: '数字化采购平台_电子采购平台_供应链采购平台|金现代数字化采购平台',
            keywords: '数字化采购管理，采购管理系统，电子招采平台，采购平台，电子招投标',
            description: '金现代数字化采购平台，是一款涉及招采全流程、覆盖招采全业务的标准化采购平台，解决企业招采周期长、成本高、流程不规范等问题，助力企业快速稳步发展。'
        }
    },
]

const router = new VueRouter({
    mode: 'hash',
    routes,
})
router.beforeEach((to, from, next) => {
    if (to.meta.keywords) {
        document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.keywords);
    }
    if (to.meta.description) {
        document.querySelector('meta[name="description"]').setAttribute('content', to.meta.description);
    }
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
})

export default router
